"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadingAssetCard = UploadingAssetCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const UploadingAssetCard_style_1 = require("./UploadingAssetCard.style");
function UploadingAssetCard({ uploadingAsset }) {
    return ((0, jsx_runtime_1.jsxs)(UploadingAssetCard_style_1.UploadingAssetCardContainer, { children: [(0, jsx_runtime_1.jsx)(UploadingAssetCard_style_1.UploadingAssetCardContent, { children: (0, jsx_runtime_1.jsx)(elements_1.Progress, { type: "circle", percent: uploadingAsset.progressPercentage }) }), (0, jsx_runtime_1.jsx)(UploadingAssetCard_style_1.UploadingAssetCardFooter, { children: (0, jsx_runtime_1.jsx)(UploadingAssetCard_style_1.UploadingAssetCardFooterText, { children: uploadingAsset.file.name }) })] }));
}
